import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { WalletSummaryModel } from '../models/walletSummaryModel';
import { SettingService } from '../services/setting.service';
import { TierService } from '../services/tier.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  closeResult: string;

  constructor(public settingService: SettingService,public tierService:TierService) {}
  walletSummary: WalletSummaryModel=new WalletSummaryModel();
  walletExpiryDate:string;

  ngOnInit() {
    this.settingService.pageName='home';
    this.getSummary();
    this.reload();
  }
  openModal() {
    this.settingService.showErrorPopup();
  }
  getSummary()
  {
    this.tierService.getWalletSammary().subscribe(res=>{
      localStorage.walletId=res.walletId;
       this.walletSummary=res;
      this.settingService.setWalletSummary(res);
      this.walletExpiryDate=new Date(this.walletSummary.expiryDate).toLocaleDateString(this.settingService.lang, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

    });
    // this.setting.walletSummary.subscribe(res=>{
    //    this.walletSummary=res;
    // });
  }

reload() {
  this.settingService.languageEvent.subscribe(res => {
    this.walletExpiryDate=new Date(this.walletSummary.expiryDate).toLocaleDateString(this.settingService.lang, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    // this.getCategories();
  });
}
}
